import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import "./assets/css/index.less";
import { Button, Tabs, TabPane, Input } from 'element-ui';

Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Input)
Vue.config.productionTip = false

router.beforeEach((to,from,next) =>{
  if(to.meta.title){
    document.title = i18n.t(to.meta.title)
  }
  next()
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
